// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Page */
.adminUsersPage{
  background: var(--white-principale);
  min-height: 100vh;
  padding: 12px 0 26px;
  font-family: Arial, sans-serif;
}

/* Grid (carte centrée) */
.adminUsersGrid{
  display:flex;
  justify-content: center;
}

/* Card */
.adminUsersCard{
  border-radius: 12px;
  background: var(--white-principale);
  box-shadow: 0 1px 10px rgba(0,0,0,.14);
  padding: 16px;
}

.adminUsersCardCenter{
  width: 100%;
  max-width: 1100px;
  margin-top: 16px;
}

/* Header */
.adminUsersHeader{
  display:flex;
  align-items:flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.adminUsersTitle{
  font-weight: 900;
  font-size: 14px;
  color: var(--couleur-dark);
}

.adminUsersSubtitle{
  margin-top: 4px;
  font-size: 12px;
  color: var(--gris-terciaire);
}

/* Buttons */
.adminUsersBtn{
  border: none;
  border-radius: 999px;
  padding: 8px 12px;
  font-weight: 800;
  font-size: 12px;
  cursor: pointer;
  display:flex;
  align-items:center;
  gap: 8px;
  transition: filter .15s ease, opacity .15s ease;
}

.adminUsersBtnSoft{
  background: rgba(0,0,0,.06);
  color: var(--couleur-dark);
}

.adminUsersBtnSoft:hover{
  filter: brightness(0.96);
}

.adminUsersBtn:disabled{
  opacity: .6;
  cursor: default;
}

/* Filters */
.adminUsersFilters{
  display:flex;
  align-items:center;
  gap: 12px;
  flex-wrap: wrap;
  margin: 12px 0 14px;
}

.adminUsersSearch{
  flex: 1 1 360px;
  min-width: 260px;
  display:flex;
  align-items:center;
  gap: 8px;
  border: 1px solid var(--gris-secondaire-2);
  border-radius: 999px;
  padding: 8px 12px;
  background: var(--white-principale);
}

.adminUsersSearch i{
  color: var(--gris-terciaire);
}

.adminUsersSearch input{
  border: none;
  outline: none;
  width: 100%;
  font-size: 12px;
  color: var(--couleur-dark);
  background: transparent;
}

.adminUsersSelects{
  display:flex;
  gap: 10px;
  flex-wrap: wrap;
}

.adminUsersSelects select{
  height: 34px;
  border-radius: 10px;
  border: 1px solid var(--gris-secondaire-2);
  padding: 0 10px;
  font-size: 12px;
  color: var(--couleur-dark);
  background: var(--white-principale);
  outline: none;
}

/* Table */
.adminUsersTableWrap{
  width: 100%;
  overflow-x: auto;
  border: 1px solid var(--gris-secondaire-2);
  border-radius: 12px;
}

.adminUsersTable{
  width: 100%;
  border-collapse: collapse;
  min-width: 980px;
}

.adminUsersTable thead th{
  text-align: left;
  font-size: 11px;
  color: var(--gris-terciaire);
  font-weight: 900;
  padding: 12px 12px;
  background: rgba(0,0,0,.03);
  border-bottom: 1px solid var(--gris-secondaire-2);
}

.adminUsersTable tbody td{
  padding: 12px 12px;
  border-bottom: 1px solid rgba(0,0,0,.06);
  font-size: 12px;
  color: var(--couleur-dark);
  vertical-align: middle;
}

.adminUsersTable tbody tr:hover{
  background: rgba(0,0,0,.02);
}

.muted{
  color: var(--gris-terciaire);
}

/* User cell */
.adminUsersCellUser{
  display:flex;
  align-items:center;
  gap: 10px;
  min-width: 240px;
}

.adminUsersAvatar{
  width: 34px;
  height: 34px;
  border-radius: 999px;
  display:flex;
  align-items:center;
  justify-content:center;
  background: rgba(0,0,0,.06);
  font-weight: 900;
  color: var(--couleur-dark);
  flex: 0 0 auto;
}

.adminUsersCellUserText{
  min-width: 0;
}

.adminUsersName{
  font-weight: 900;
  font-size: 12px;
  color: var(--couleur-dark);
  line-height: 1.1;
}

.adminUsersId{
  margin-top: 2px;
  font-size: 10px;
  color: var(--gris-terciaire);
  overflow:hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 320px;
}

/* Badges */
.adminUsersBadge{
  display:inline-flex;
  align-items:center;
  height: 22px;
  padding: 0 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 900;
  letter-spacing: .02em;
  border: 1px solid rgba(0,0,0,.08);
}

.badgeAdmin{
  background: rgba(43,80,255,.12);
  color: var(--couleur-principale);
  border-color: rgba(43,80,255,.18);
}

.badgeUser{
  background: rgba(0,0,0,.06);
  color: var(--couleur-dark);
}

.badgeActive{
  background: rgba(28,180,93,.12);
  color: #1cb45d;
  border-color: rgba(28,180,93,.18);
}

.badgeBlocked{
  background: rgba(220,53,69,.12);
  color: #dc3545;
  border-color: rgba(220,53,69,.18);
}

/* Actions */
.colActions{
  width: 110px;
}

.adminUsersActions{
  display:flex;
  justify-content:flex-end;
  gap: 8px;
}

.adminUsersIconBtn{
  width: 34px;
  height: 34px;
  border-radius: 10px;
  border: 1px solid rgba(0,0,0,.08);
  background: var(--white-principale);
  display:flex;
  align-items:center;
  justify-content:center;
  cursor: pointer;
  transition: filter .15s ease, transform .06s ease;
}

.adminUsersIconBtn:hover{
  filter: brightness(0.98);
}

.adminUsersIconBtn:active{
  transform: scale(0.98);
}

.adminUsersIconBtn.danger{
  border-color: rgba(220,53,69,.25);
  color: #dc3545;
}

/* Empty / Loader */
.adminUsersEmpty{
  padding: 22px 8px;
  display:flex;
  flex-direction: column;
  align-items:center;
  justify-content:center;
  gap: 10px;
  color: var(--gris-terciaire);
  text-align:center;
}

.adminUsersEmpty i{
  font-size: 22px;
}

.adminUsersSpinner{
  width: 22px;
  height: 22px;
  border-radius: 999px;
  border: 2px solid rgba(0,0,0,.18);
  border-top-color: rgba(0,0,0,.45);
  animation: spin .8s linear infinite;
}

@keyframes spin{
  to { transform: rotate(360deg); }
}

/* Pagination */
.adminUsersPagination{
  margin-top: 14px;
  display:flex;
  align-items:center;
  justify-content:center;
  gap: 10px;
}

.adminUsersPageBtn{
  width: 36px;
  height: 36px;
  border-radius: 12px;
  border: 1px solid rgba(0,0,0,.08);
  background: var(--white-principale);
  cursor: pointer;
  display:flex;
  align-items:center;
  justify-content:center;
  transition: filter .15s ease;
}

.adminUsersPageBtn:hover{
  filter: brightness(0.98);
}

.adminUsersPageBtn:disabled{
  opacity: .55;
  cursor: default;
}

.adminUsersPageInfo{
  font-size: 12px;
  color: var(--gris-terciaire);
}

.adminUsersAvatar{
  width: 34px;
  height: 34px;
  border-radius: 999px;
  overflow: hidden;
  background: rgba(0,0,0,.06);
  flex: 0 0 auto;
  display:flex;
  align-items:center;
  justify-content:center;
}

.adminUsersAvatar img{
  width: 100%;
  height: 100%;
  object-fit: cover;
  display:block;
}

.adminUsersSkeletonWrap{
  width: 100%;
  border: 1px solid var(--gris-secondaire-2);
  border-radius: 12px;
  padding: 12px;
  overflow: hidden;
  background: var(--white-principale);
}

.user_lock{
  color: #dc3545;
}

.user_open{
  color: #1cb45d;
}

.hideOnMobile { display: table-cell; }
.adminUsersMobileMeta { display: none; }

/* Responsive */
@media (max-width: 720px){
  .hideOnMobile { display: none !important; }

  .adminUsersTable{ min-width: 0; }
  .adminUsersTable thead{ display:none; }

  .adminUsersTable,
  .adminUsersTableWrap{
    border: none;
  }

  .adminUsersTable tbody{
    display:flex;
    flex-direction: column;
    gap: 10px;
  }

  .adminUsersTable tbody tr{
    display:block;
    border: 1px solid var(--gris-secondaire-2);
    border-radius: 14px;
    padding: 10px;
    background: var(--white-principale);
  }

  .adminUsersTable tbody td{
    display:block;
    border-bottom: none;
    padding: 6px 4px;
  }

  .colActions{
    width: auto;
  }

  .adminUsersActions{
    justify-content: flex-end;
    margin-top: 6px;
  }

  .adminUsersCellUser{
    min-width: 0;
  }

  .adminUsersId{
    max-width: 100%;
  }

  .adminUsersMobileMeta{
    display:block;
    margin-top: 8px;
    font-size: 11px;
    color: var(--gris-terciaire);
    line-height: 1.35;
  }

  .adminUsersMobileMeta div{
    display:flex;
    align-items:center;
    gap: 8px;
    margin-top: 4px;
  }

  .adminUsersMobileMeta i{
    opacity: .8;
  }
}

.adminUsersModalOverlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 16px;
}

.adminUsersModal {
  width: 100%;
  max-width: 390px;
  background: var(--white-principale);
  border-radius: 18px;
  padding: 22px;
  text-align: center;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.22);
  animation: adminUsersModalIn 0.18s ease;
}

@keyframes adminUsersModalIn {
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.adminUsersModalIcon {
  width: 52px;
  height: 52px;
  border-radius: 999px;
  margin: 0 auto 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(220, 53, 69, 0.1);
  color: #dc3545;
  font-size: 24px;
}

.adminUsersModal h3 {
  margin: 0;
  font-size: 17px;
  font-weight: 900;
  color: var(--couleur-dark);
}

.adminUsersModal p {
  margin: 10px 0;
  font-size: 13px;
  color: var(--gris-terciaire);
  line-height: 1.45;
}

.adminUsersModalUser {
  margin: 12px auto 18px;
  display: inline-flex;
  padding: 7px 13px;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.05);
  font-size: 12px;
  font-weight: 800;
  color: var(--couleur-dark);
}

.adminUsersModalActions {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.adminUsersModalCancel,
.adminUsersModalConfirm {
  border: none;
  border-radius: 999px;
  padding: 9px 16px;
  font-size: 12px;
  font-weight: 900;
  cursor: pointer;
}

.adminUsersModalCancel {
  background: rgba(0, 0, 0, 0.07);
  color: var(--couleur-dark);
}

.adminUsersModalConfirm.danger {
  background: #dc3545;
  color: #fff;
}

.adminUsersModalConfirm.success {
  background: #1cb45d;
  color: #fff;
}

.adminUsersModalCancel:hover,
.adminUsersModalConfirm:hover {
  filter: brightness(0.96);
}

.adminUserTest{
  background: rgb(124 58 237 / 18%);
  border-left: 3px solid var(--kpi-users-fg);
}

.adminUserTest:hover{
  background: rgba(46, 3, 121, 0.14) !important;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/admin/gestionUtilisateur/AdminUsersPage.css"],"names":[],"mappings":"AAAA,SAAS;AACT;EACE,mCAAmC;EACnC,iBAAiB;EACjB,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA,yBAAyB;AACzB;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA,SAAS;AACT;EACE,mBAAmB;EACnB,mCAAmC;EACnC,sCAAsC;EACtC,aAAa;AACf;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,YAAY;EACZ,sBAAsB;EACtB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,4BAA4B;AAC9B;;AAEA,YAAY;AACZ;EACE,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,0CAA0C;EAC1C,oBAAoB;EACpB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,eAAe;EACf,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,eAAe;EACf,eAAe;EACf,0BAA0B;EAC1B,mCAAmC;EACnC,aAAa;AACf;;AAEA,UAAU;AACV;EACE,WAAW;EACX,gBAAgB;EAChB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;EAC3B,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,cAAc;AACd;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,2BAA2B;EAC3B,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,4BAA4B;EAC5B,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,iCAAiC;AACnC;;AAEA,YAAY;AACZ;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,wBAAwB;EACxB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iCAAiC;EACjC,mCAAmC;EACnC,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;EACT,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,iCAAiC;EACjC,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iCAAiC;EACjC,mCAAmC;EACnC,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,2BAA2B;EAC3B,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,gBAAgB,mBAAmB,EAAE;AACrC,wBAAwB,aAAa,EAAE;;AAEvC,eAAe;AACf;EACE,gBAAgB,wBAAwB,EAAE;;EAE1C,kBAAkB,YAAY,EAAE;EAChC,wBAAwB,YAAY,EAAE;;EAEtC;;IAEE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,0CAA0C;IAC1C,mBAAmB;IACnB,aAAa;IACb,mCAAmC;EACrC;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,eAAe;IACf,4BAA4B;IAC5B,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,2CAA2C;EAC3C,uCAAuC;AACzC;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;;EAEE,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,iCAAiC;EACjC,0CAA0C;AAC5C;;AAEA;EACE,6CAA6C;AAC/C","sourcesContent":["/* Page */\n.adminUsersPage{\n  background: var(--white-principale);\n  min-height: 100vh;\n  padding: 12px 0 26px;\n  font-family: Arial, sans-serif;\n}\n\n/* Grid (carte centrée) */\n.adminUsersGrid{\n  display:flex;\n  justify-content: center;\n}\n\n/* Card */\n.adminUsersCard{\n  border-radius: 12px;\n  background: var(--white-principale);\n  box-shadow: 0 1px 10px rgba(0,0,0,.14);\n  padding: 16px;\n}\n\n.adminUsersCardCenter{\n  width: 100%;\n  max-width: 1100px;\n  margin-top: 16px;\n}\n\n/* Header */\n.adminUsersHeader{\n  display:flex;\n  align-items:flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.adminUsersTitle{\n  font-weight: 900;\n  font-size: 14px;\n  color: var(--couleur-dark);\n}\n\n.adminUsersSubtitle{\n  margin-top: 4px;\n  font-size: 12px;\n  color: var(--gris-terciaire);\n}\n\n/* Buttons */\n.adminUsersBtn{\n  border: none;\n  border-radius: 999px;\n  padding: 8px 12px;\n  font-weight: 800;\n  font-size: 12px;\n  cursor: pointer;\n  display:flex;\n  align-items:center;\n  gap: 8px;\n  transition: filter .15s ease, opacity .15s ease;\n}\n\n.adminUsersBtnSoft{\n  background: rgba(0,0,0,.06);\n  color: var(--couleur-dark);\n}\n\n.adminUsersBtnSoft:hover{\n  filter: brightness(0.96);\n}\n\n.adminUsersBtn:disabled{\n  opacity: .6;\n  cursor: default;\n}\n\n/* Filters */\n.adminUsersFilters{\n  display:flex;\n  align-items:center;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin: 12px 0 14px;\n}\n\n.adminUsersSearch{\n  flex: 1 1 360px;\n  min-width: 260px;\n  display:flex;\n  align-items:center;\n  gap: 8px;\n  border: 1px solid var(--gris-secondaire-2);\n  border-radius: 999px;\n  padding: 8px 12px;\n  background: var(--white-principale);\n}\n\n.adminUsersSearch i{\n  color: var(--gris-terciaire);\n}\n\n.adminUsersSearch input{\n  border: none;\n  outline: none;\n  width: 100%;\n  font-size: 12px;\n  color: var(--couleur-dark);\n  background: transparent;\n}\n\n.adminUsersSelects{\n  display:flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.adminUsersSelects select{\n  height: 34px;\n  border-radius: 10px;\n  border: 1px solid var(--gris-secondaire-2);\n  padding: 0 10px;\n  font-size: 12px;\n  color: var(--couleur-dark);\n  background: var(--white-principale);\n  outline: none;\n}\n\n/* Table */\n.adminUsersTableWrap{\n  width: 100%;\n  overflow-x: auto;\n  border: 1px solid var(--gris-secondaire-2);\n  border-radius: 12px;\n}\n\n.adminUsersTable{\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 980px;\n}\n\n.adminUsersTable thead th{\n  text-align: left;\n  font-size: 11px;\n  color: var(--gris-terciaire);\n  font-weight: 900;\n  padding: 12px 12px;\n  background: rgba(0,0,0,.03);\n  border-bottom: 1px solid var(--gris-secondaire-2);\n}\n\n.adminUsersTable tbody td{\n  padding: 12px 12px;\n  border-bottom: 1px solid rgba(0,0,0,.06);\n  font-size: 12px;\n  color: var(--couleur-dark);\n  vertical-align: middle;\n}\n\n.adminUsersTable tbody tr:hover{\n  background: rgba(0,0,0,.02);\n}\n\n.muted{\n  color: var(--gris-terciaire);\n}\n\n/* User cell */\n.adminUsersCellUser{\n  display:flex;\n  align-items:center;\n  gap: 10px;\n  min-width: 240px;\n}\n\n.adminUsersAvatar{\n  width: 34px;\n  height: 34px;\n  border-radius: 999px;\n  display:flex;\n  align-items:center;\n  justify-content:center;\n  background: rgba(0,0,0,.06);\n  font-weight: 900;\n  color: var(--couleur-dark);\n  flex: 0 0 auto;\n}\n\n.adminUsersCellUserText{\n  min-width: 0;\n}\n\n.adminUsersName{\n  font-weight: 900;\n  font-size: 12px;\n  color: var(--couleur-dark);\n  line-height: 1.1;\n}\n\n.adminUsersId{\n  margin-top: 2px;\n  font-size: 10px;\n  color: var(--gris-terciaire);\n  overflow:hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 320px;\n}\n\n/* Badges */\n.adminUsersBadge{\n  display:inline-flex;\n  align-items:center;\n  height: 22px;\n  padding: 0 10px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 900;\n  letter-spacing: .02em;\n  border: 1px solid rgba(0,0,0,.08);\n}\n\n.badgeAdmin{\n  background: rgba(43,80,255,.12);\n  color: var(--couleur-principale);\n  border-color: rgba(43,80,255,.18);\n}\n\n.badgeUser{\n  background: rgba(0,0,0,.06);\n  color: var(--couleur-dark);\n}\n\n.badgeActive{\n  background: rgba(28,180,93,.12);\n  color: #1cb45d;\n  border-color: rgba(28,180,93,.18);\n}\n\n.badgeBlocked{\n  background: rgba(220,53,69,.12);\n  color: #dc3545;\n  border-color: rgba(220,53,69,.18);\n}\n\n/* Actions */\n.colActions{\n  width: 110px;\n}\n\n.adminUsersActions{\n  display:flex;\n  justify-content:flex-end;\n  gap: 8px;\n}\n\n.adminUsersIconBtn{\n  width: 34px;\n  height: 34px;\n  border-radius: 10px;\n  border: 1px solid rgba(0,0,0,.08);\n  background: var(--white-principale);\n  display:flex;\n  align-items:center;\n  justify-content:center;\n  cursor: pointer;\n  transition: filter .15s ease, transform .06s ease;\n}\n\n.adminUsersIconBtn:hover{\n  filter: brightness(0.98);\n}\n\n.adminUsersIconBtn:active{\n  transform: scale(0.98);\n}\n\n.adminUsersIconBtn.danger{\n  border-color: rgba(220,53,69,.25);\n  color: #dc3545;\n}\n\n/* Empty / Loader */\n.adminUsersEmpty{\n  padding: 22px 8px;\n  display:flex;\n  flex-direction: column;\n  align-items:center;\n  justify-content:center;\n  gap: 10px;\n  color: var(--gris-terciaire);\n  text-align:center;\n}\n\n.adminUsersEmpty i{\n  font-size: 22px;\n}\n\n.adminUsersSpinner{\n  width: 22px;\n  height: 22px;\n  border-radius: 999px;\n  border: 2px solid rgba(0,0,0,.18);\n  border-top-color: rgba(0,0,0,.45);\n  animation: spin .8s linear infinite;\n}\n\n@keyframes spin{\n  to { transform: rotate(360deg); }\n}\n\n/* Pagination */\n.adminUsersPagination{\n  margin-top: 14px;\n  display:flex;\n  align-items:center;\n  justify-content:center;\n  gap: 10px;\n}\n\n.adminUsersPageBtn{\n  width: 36px;\n  height: 36px;\n  border-radius: 12px;\n  border: 1px solid rgba(0,0,0,.08);\n  background: var(--white-principale);\n  cursor: pointer;\n  display:flex;\n  align-items:center;\n  justify-content:center;\n  transition: filter .15s ease;\n}\n\n.adminUsersPageBtn:hover{\n  filter: brightness(0.98);\n}\n\n.adminUsersPageBtn:disabled{\n  opacity: .55;\n  cursor: default;\n}\n\n.adminUsersPageInfo{\n  font-size: 12px;\n  color: var(--gris-terciaire);\n}\n\n.adminUsersAvatar{\n  width: 34px;\n  height: 34px;\n  border-radius: 999px;\n  overflow: hidden;\n  background: rgba(0,0,0,.06);\n  flex: 0 0 auto;\n  display:flex;\n  align-items:center;\n  justify-content:center;\n}\n\n.adminUsersAvatar img{\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display:block;\n}\n\n.adminUsersSkeletonWrap{\n  width: 100%;\n  border: 1px solid var(--gris-secondaire-2);\n  border-radius: 12px;\n  padding: 12px;\n  overflow: hidden;\n  background: var(--white-principale);\n}\n\n.user_lock{\n  color: #dc3545;\n}\n\n.user_open{\n  color: #1cb45d;\n}\n\n.hideOnMobile { display: table-cell; }\n.adminUsersMobileMeta { display: none; }\n\n/* Responsive */\n@media (max-width: 720px){\n  .hideOnMobile { display: none !important; }\n\n  .adminUsersTable{ min-width: 0; }\n  .adminUsersTable thead{ display:none; }\n\n  .adminUsersTable,\n  .adminUsersTableWrap{\n    border: none;\n  }\n\n  .adminUsersTable tbody{\n    display:flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .adminUsersTable tbody tr{\n    display:block;\n    border: 1px solid var(--gris-secondaire-2);\n    border-radius: 14px;\n    padding: 10px;\n    background: var(--white-principale);\n  }\n\n  .adminUsersTable tbody td{\n    display:block;\n    border-bottom: none;\n    padding: 6px 4px;\n  }\n\n  .colActions{\n    width: auto;\n  }\n\n  .adminUsersActions{\n    justify-content: flex-end;\n    margin-top: 6px;\n  }\n\n  .adminUsersCellUser{\n    min-width: 0;\n  }\n\n  .adminUsersId{\n    max-width: 100%;\n  }\n\n  .adminUsersMobileMeta{\n    display:block;\n    margin-top: 8px;\n    font-size: 11px;\n    color: var(--gris-terciaire);\n    line-height: 1.35;\n  }\n\n  .adminUsersMobileMeta div{\n    display:flex;\n    align-items:center;\n    gap: 8px;\n    margin-top: 4px;\n  }\n\n  .adminUsersMobileMeta i{\n    opacity: .8;\n  }\n}\n\n.adminUsersModalOverlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  padding: 16px;\n}\n\n.adminUsersModal {\n  width: 100%;\n  max-width: 390px;\n  background: var(--white-principale);\n  border-radius: 18px;\n  padding: 22px;\n  text-align: center;\n  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.22);\n  animation: adminUsersModalIn 0.18s ease;\n}\n\n@keyframes adminUsersModalIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px) scale(0.98);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.adminUsersModalIcon {\n  width: 52px;\n  height: 52px;\n  border-radius: 999px;\n  margin: 0 auto 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(220, 53, 69, 0.1);\n  color: #dc3545;\n  font-size: 24px;\n}\n\n.adminUsersModal h3 {\n  margin: 0;\n  font-size: 17px;\n  font-weight: 900;\n  color: var(--couleur-dark);\n}\n\n.adminUsersModal p {\n  margin: 10px 0;\n  font-size: 13px;\n  color: var(--gris-terciaire);\n  line-height: 1.45;\n}\n\n.adminUsersModalUser {\n  margin: 12px auto 18px;\n  display: inline-flex;\n  padding: 7px 13px;\n  border-radius: 999px;\n  background: rgba(0, 0, 0, 0.05);\n  font-size: 12px;\n  font-weight: 800;\n  color: var(--couleur-dark);\n}\n\n.adminUsersModalActions {\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n}\n\n.adminUsersModalCancel,\n.adminUsersModalConfirm {\n  border: none;\n  border-radius: 999px;\n  padding: 9px 16px;\n  font-size: 12px;\n  font-weight: 900;\n  cursor: pointer;\n}\n\n.adminUsersModalCancel {\n  background: rgba(0, 0, 0, 0.07);\n  color: var(--couleur-dark);\n}\n\n.adminUsersModalConfirm.danger {\n  background: #dc3545;\n  color: #fff;\n}\n\n.adminUsersModalConfirm.success {\n  background: #1cb45d;\n  color: #fff;\n}\n\n.adminUsersModalCancel:hover,\n.adminUsersModalConfirm:hover {\n  filter: brightness(0.96);\n}\n\n.adminUserTest{\n  background: rgb(124 58 237 / 18%);\n  border-left: 3px solid var(--kpi-users-fg);\n}\n\n.adminUserTest:hover{\n  background: rgba(46, 3, 121, 0.14) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
